import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cookie from 'react-cookie';
import {
  beginsWithVowel,
  createRandomPassword,
  flashHighlight,
} from 'helpers/HelperFunctions';

// Please pass { specificFreeLancer: this.state.specificFreelancerSelected }
// with every trackEvent function triggered in Post.js. This allows us to track
// the difference between behaviour for those two flows throughout the post flow
import { trackEvent } from 'helpers/Analytics';

import Button from 'react-bootstrap/lib/Button';
import Clearfix from 'react-bootstrap/lib/Clearfix';
import Col from 'react-bootstrap/lib/Col';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';

import PostBoost from 'components/Post/PostBoost/PostBoost';
import PostBudget from 'components/Post/PostBudget/PostBudget';
import PostContactDetails from 'components/Post/PostContactDetails/PostContactDetails';
import PostDescription from 'components/Post/PostDescription/PostDescription';
import PostFlowIndicator from 'components/Post/PostFlowIndicator/PostFlowIndicator';
import PostFooter from 'components/Post/PostFooter/PostFooter';
import PostHelp from 'components/Post/PostHelp/PostHelp';
import PostQuestion from 'components/Post/PostQuestion/PostQuestion';
import PostRemote from 'components/Post/PostRemote/PostRemote';
import PostScheduleCall from 'components/Post/PostScheduleCall/PostScheduleCall';
import PostSearchCreatives from 'components/Post/PostSearchCreatives/PostSearchCreatives';
import PostSelectRole from 'components/Post/PostSelectRole/PostSelectRole';
import PostStepsIndicator from 'components/Post/PostStepsIndicator/PostStepsIndicator';
// import PostValidate from 'components/Post/PostValidate/PostValidate';
// import PostVoucherInfo from 'components/Post/PostVoucherInfo/PostVoucherInfo';
import ExplainerVideoModal from 'components/LandingPage/ExplainerVideoModal/ExplainerVideoModal';
import LazyLoad from 'components/LazyLoad/LazyLoad';

import Helmet from 'react-helmet';

import cocacola from 'components/LandingPage/LandingClientsSection/cocacola.png';
import disney from 'components/LandingPage/LandingClientsSection/disney.png';
import mtv from 'components/LandingPage/LandingClientsSection/mtv.png';
import muppets from 'components/LandingPage/LandingClientsSection/muppets.png';
import nokia from 'components/LandingPage/LandingClientsSection/nokia.png';
import starWars from 'components/LandingPage/LandingClientsSection/star-wars.png';
import { CONTACT_SENT_SUCCESS } from 'constants/successMessages';
import { SHORTEST_INTL_PHONE_LENGTH } from 'constants/constants';
import config from '../../config';
import styles from './Post.module.scss';
import PostSignUp from 'components/Post/PostSignUp/PostSignUp';
import Recaptcha from 'react-google-invisible-recaptcha';
import Loader from 'components/Loader/Loader';

export default class Post extends Component {
  static propTypes = {
    authUser: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    ownBriefs: PropTypes.shape({
      collaborations: PropTypes.array,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }),
    loadOwnBriefs: PropTypes.func,
    emailError: PropTypes.array,
    // loadedPaymentToken: PropTypes.bool,
    loadedSuggestedRoles: PropTypes.bool,
    loadedSuggestedSkills: PropTypes.bool,
    loadingAuth: PropTypes.bool,
    // loadingPaymentToken: PropTypes.bool,
    loadingSuggestedRoles: PropTypes.bool,
    loadingSuggestedSkills: PropTypes.bool,
    loadUser: PropTypes.func,
    location: PropTypes.object,
    passwordError: PropTypes.array,
    // paymentToken: PropTypes.string,
    postedBrief: PropTypes.object,
    postingBrief: PropTypes.bool,
    roleEntities: PropTypes.object,
    // savingBraintreeNonce: PropTypes.bool,
    setSuccessMessage: PropTypes.func,
    signingUp: PropTypes.bool,
    signedUpToGoogle: PropTypes.bool,
    signingUpViaGoogle: PropTypes.bool,
    userId: PropTypes.number,
    skillEntities: PropTypes.object,
    suggestedRoles: PropTypes.array,
    suggestedSkills: PropTypes.array,
    stats: PropTypes.object,
    // functions
    // getPaymentToken: PropTypes.func,
    inviteUser: PropTypes.func,
    loadAuth: PropTypes.func,
    loadSuggestedRoles: PropTypes.func,
    loadSuggestedSkills: PropTypes.func,
    loadStats: PropTypes.func,
    postBrief: PropTypes.func,
    // saveBraintreeNonce: PropTypes.func,
    signUp: PropTypes.func,
    googleOAuthRedirect: PropTypes.func,
    sendGoogleOAuthCode: PropTypes.func,
    updateAuthUser: PropTypes.func,
    users: PropTypes.object,
    authState: PropTypes.object,
    authLoaded: PropTypes.bool,
  };

  // static defaultProps = {
  //   location: {
  //     query: {
  //       freelancerId: null,
  //     },
  //   },
  // };

  constructor(props) {
    super(props);

    this.state = {
      answers: {},
      autoSelectedRole: false,
      budget: 0,
      currency:
        props.authUser &&
        props.authUser.location &&
        props.authUser.location.country_code === 'gb'
          ? 'gbp'
          : 'usd',
      wasCurrencyUpdatedByUser: false,
      currentStep: 1,
      description: cookie.load('post-description')
        ? cookie.load('post-description')
        : '',
      email: cookie.load('post-email') ? cookie.load('post-email') : '',
      emailDirty: false,
      enteredPostDescription: false,
      externalUrl: '',
      freelancer: props.users[props.location.query.freelancerId],
      fixedBudget: false,
      isFirstJob: props.ownBriefs.collaborations.length <= 0,
      isPrivate: false, // 'private' is a keyword in JS
      localError: '',
      password: cookie.load('post-email') ? createRandomPassword() : '', // Generate an automatic password when email set
      passwordDirty: false,
      phoneNumber: props.authUser
        ? props.authUser.phone
        : cookie.load('post-phone')
        ? cookie.load('post-phone')
        : '',
      phoneNumberUpdated: false,
      questionsSeen: [],
      searching: false,
      showContinue: false,
      specificFreelancerSelected: !!props.location.query.freelancerId,
      selectedRole: null,
      // showValidateStep: props.authUser ? ! props.authUser.braintree_linked : true,
      // showValidateStep: false,
      title: cookie.load('post-title') ? cookie.load('post-title') : '',
      titleChangedByUser: false,
      userContactOptions: props.authUser
        ? props.authUser.contact_options
        : { email: true, phone: true, sms: true },
      userContactOptionsUpdated: false,
      links: '',
      // showTrustSectionAB: (Math.random() >= 0.5) ? 'b' : 'a',
      showTrustSectionAB: 'b',
      signUpDetails: null,
      showExplainer: false,
      workLocallyLocation: null,
      workRemotely: true,
      countryOnly: null,
      emailError: null,
      passwordError: null,
    };
  }

  UNSAFE_componentWillMount() {
    const {
      history,
      match: { params },
    } = this.props;

    if (
      !params.role &&
      (typeof cookie.load('role') !== 'undefined' ||
        typeof cookie.load('skill') !== 'undefined')
    ) {
      const cookieRole = (cookie.load('role') || cookie.load('skill')).replace(
        '+',
        ' '
      );
      cookie.remove('role');
      cookie.remove('skill');
      history.push(`/post/${cookieRole}`);
    }

    // if (this.state.showValidateStep) {
    //   const abValue = Math.floor(Math.random() * 10) < 2 ? 'b' : 'a';

    //   if (abValue === 'b') {
    //     this.setState({
    //       showValidateStep: false,
    //     });
    //   }
    // }
  }

  componentDidMount() {
    const {
      authUser,
      match: { params },
      location: {
        query: { freelancerId },
      },
      stats,
      loadStats,

      loadSuggestedRoles,
      loadingSuggestedRoles,
      loadedSuggestedRoles,

      loadSuggestedSkills,
      loadingSuggestedSkills,
      loadedSuggestedSkills,

      loadUser,
      users,
      authState,
      authLoaded,
      loadAuth,
    } = this.props;
    this.handleGoogleOAuthCode();

    if (authState && authLoaded && !authUser) {
      loadAuth();
    }

    if (__CLIENT__) {
      document.body.classList.add('white-background');
    }

    if (freelancerId && !users[freelancerId]) {
      loadUser(freelancerId);
    }

    if (!stats.loadingStats && !stats.loadedStats) {
      loadStats();
    }

    if (!loadingSuggestedRoles && !loadedSuggestedRoles) {
      loadSuggestedRoles();
    }

    if (!loadingSuggestedSkills && !loadedSuggestedSkills) {
      loadSuggestedSkills();
    }

    // Check after loaded roles & skills
    if (loadedSuggestedRoles && loadedSuggestedSkills && params.role) {
      this.selectRoleByName(params.role, true);
    }

    // Import get parameters into cookies for pre-populating the post flow
    const expires = new Date();
    expires.setTime(expires.getTime() + 5 * 60 * 1000); // 5 minutes from now
    const getParams = new URLSearchParams(this.props.location.search);
    const getDescription = getParams.get('description');
    const getTitle = getParams.get('title');
    const getCapacity = getParams.get('capacity');
    const getProcess = getParams.get('process');
    const getSize = getParams.get('size');
    const getTime = getParams.get('time');
    const getEmail = getParams.get('email');
    const getPhone = getParams.get('phone');

    if (getDescription) {
      cookie.save('post-description', getDescription, { path: '/', expires });
      this.setState({ description: getDescription });
    }
    if (getTitle) {
      cookie.save('post-title', getTitle, { path: '/', expires });
      this.setState({ title: getTitle });
    }
    if (getCapacity) {
      cookie.save('post-capacity', getCapacity, { path: '/', expires });
    }
    if (getProcess) {
      cookie.save('post-process', getProcess, { path: '/', expires });
    }
    if (getSize) {
      cookie.save('post-size', getSize, { path: '/', expires });
    }
    if (getTime) {
      cookie.save('post-time', getTime, { path: '/', expires });
    }
    if (getEmail) {
      cookie.save('post-email', getEmail, { path: '/', expires });
      this.setState({
        email: getEmail,
        password: createRandomPassword(),
        userContactOptionsUpdated: true,
      });
    }
    if (getPhone) {
      cookie.save('post-phone', getPhone, { path: '/', expires });
      this.setState({
        phoneNumber: getPhone,
        phoneNumberUpdated: true,
        userContactOptionsUpdated: true,
      });
    }

    if (typeof params?.role === 'undefined') {
      this.resumeBrief();
    }

    if (__CLIENT__) {
      // Enable navigation prompt
      window.onbeforeunload = () => true;
    }

    const { showTrustSectionAB, specificFreelancerSelected } = this.state;

    trackEvent('post-loaded', {
      role: params.role || null,
      loggedIn: !!authUser,
      showTrustSectionAB,
      specificFreelancer: specificFreelancerSelected,
      moveSignUpInPostFlow: true,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      selectedRole,
      specificFreelancerSelected,
      isFirstJob,
      currentStep,
      freelancer,
    } = this.state;

    const {
      history,
      loadAuth,
      signedUpToGoogle,
      signingUp,
      passwordError,
      emailError,
      ownBriefs,
      authUser,
      loadOwnBriefs,
      loadingSuggestedRoles,
      loadedSuggestedRoles,
      match: { params },
      postingBrief,
      postedBrief,
      inviteUser,
      setSuccessMessage,
    } = this.props;

    // Handle a user who has just signed in via google
    if (!prevProps.signedUpToGoogle && signedUpToGoogle) {
      loadAuth();

      if (selectedRole && !signedUpToGoogle) {
        this.handleNext(true);
      }
    }

    // After signing up, load user
    if (
      prevProps.signingUp &&
      !signingUp &&
      passwordError.length === 0 &&
      emailError.length === 0
    ) {
      loadAuth();

      trackEvent('post-signed-up', {
        specificFreelancer: specificFreelancerSelected,
        moveSignUpInPostFlow: true,
      });
    }

    if (
      !prevProps.authUser &&
      authUser &&
      this.isSearchStep(currentStep, this.getQuestions().length) &&
      this.isSpecialRole(selectedRole) &&
      !signedUpToGoogle
    ) {
      this.handleNext();
    }

    if (
      !prevProps.authUser &&
      authUser &&
      (!ownBriefs.loaded || !prevProps.ownBriefs.loaded)
    ) {
      loadOwnBriefs(authUser.id);
    }

    if (prevProps.ownBriefs.loading && !ownBriefs.loading && ownBriefs.loaded) {
      if (prevState.isFirstJob === isFirstJob) {
        this.setState({
          // eslint-disable-line react/no-did-update-set-state
          isFirstJob: ownBriefs.collaborations.length <= 0,
        });
      }
    }

    // When a user is logged in, make sure we have a payment token
    // NO LONGER NEEDED AS NOT DOING VALIDATION
    // if (this.props.authUser && (! this.props.loadingPaymentToken) && (! this.props.loadedPaymentToken)) {
    //   this.props.getPaymentToken(this.props.authUser);
    // }

    // When a role is selected
    if (
      (!prevState.selectedRole && selectedRole) ||
      prevState.selectedRole !== selectedRole
    ) {
      trackEvent('post-selected-role', {
        role: selectedRole.name,
        specificFreelancer: specificFreelancerSelected,
        moveSignUpInPostFlow: true,
      });
    }

    // For auto select role
    if (
      prevProps.loadingSuggestedRoles &&
      !loadingSuggestedRoles &&
      loadedSuggestedRoles &&
      params.role
    ) {
      this.selectRoleByName(params.role, true);
    }

    // Finished posting brief
    if (!postingBrief && prevProps.postingBrief && postedBrief) {
      trackEvent('post-posted-brief-success', {
        specificFreelancer: specificFreelancerSelected,
        moveSignUpInPostFlow: true,
      });

      if (specificFreelancerSelected) {
        trackEvent('user-invites-freelancer', {
          type: 'specific-freelancer-post-flow',
          moveSignUpInPostFlow: true,
        });

        inviteUser(null, freelancer.id, postedBrief);
        setSuccessMessage(CONTACT_SENT_SUCCESS);
      }

      // if (! this.props.savingBraintreeNonce) {
      if (__CLIENT__ && typeof localStorage !== 'undefined') {
        this.resetLocalProgress();
      }

      history.push(`${this.props.postedBrief.links.main_relative}/review`);
    } else {
      // Update local storage for resuming
      if (
        !prevProps.postedBrief &&
        __CLIENT__ &&
        typeof localStorage !== 'undefined' &&
        selectedRole
      ) {
        this.saveLocalProgress();
      }
    }

    // If saving braintree comes back after posted brief
    // if (prevProps.savingBraintreeNonce && ! this.props.savingBraintreeNonce && this.props.postedBrief) {
    //   if (__CLIENT__ && typeof localStorage !== 'undefined') {
    //     localStorage.removeItem('postingState');
    //   }

    //   document.location = this.props.postedBrief.links.main;
    // }
  }

  componentWillUnmount() {
    if (__CLIENT__) {
      document.body.classList.remove('white-background');
      window.onbeforeunload = null;
    }
  }

  getDescriptionTemplate(num = 0) {
    const templates = {
      1: "Who are you, and what do you do?\n\nWhat's the project, and what do you need from a freelancer?\n\nWhen do you need you project delivered?\n\nCan you provide examples of your preferred style?",
      2: 'What is the project, and what do you want to achieve with it?\n\nWhat is your role within the organisation, or is this a person project?\n\nWhat are the three top priorities for this project?\n\nDo you have a deadline?\n\nAre there reference materials that can be shared to give insight into what is needed?',
    };
    return num === 0 ? templates : templates[num];
  }

  getHelpPoints(currentStep, noOfQuestions, fixedBudget = false) {
    if (this.isDescriptionStep(currentStep, noOfQuestions)) {
      let descriptionHelpPoints = [
        <span>
          Detailed descriptions attract the best freelancers and ensure you get{' '}
          <strong>quality</strong> work.
        </span>,
        'Fill in as much as you can - you can always edit it later',
      ];

      if (
        this.state.answers &&
        !Object.values(this.state.answers).includes(
          'As an individual for a personal project'
        )
      ) {
        let twineBusinessUpsell = (
          <span>
            Need help writing your brief?{' '}
            <a
              href="https://www.twine.net/enterprise"
              target="_blank"
              rel="noreferrer"
            >
              Upgrade to Twine Business
            </a>
            .
          </span>
        );
        descriptionHelpPoints.unshift(twineBusinessUpsell);
      }

      return descriptionHelpPoints;
    }

    if (this.isBudgetStep(currentStep, noOfQuestions) && fixedBudget) {
      return [
        'Set a project budget so freelancers can quote what can be achieved.',
        <span>
          Your project budget <strong>can be changed</strong> after you've
          spoken to freelancers.
        </span>,
        <span>
          Payments on Twine are covered by our{' '}
          <strong>money back guarantee</strong>.
        </span>,
      ];
    }

    if (this.isBudgetStep(currentStep, noOfQuestions) && !fixedBudget) {
      return [
        'Freelancers will contact you with their estimated rate.',
        <span>
          Payments on Twine are covered by our{' '}
          <strong>money back guarantee</strong>.
        </span>,
      ];
    }

    if (this.isContactDetailsStep(currentStep, noOfQuestions)) {
      return [
        <span>
          Your details will be kept private and will{' '}
          <strong>not be shared</strong> with any freelancers.
        </span>,
      ];
    }

    // if (this.isValidateStep(currentStep, noOfQuestions)) {
    //   return [
    //     <span>Total due now: <strong>{this.state.currency === 'gbp' ? '£' : this.state.currency === 'eur' ? '€' : '$'}0.00</strong></span>,
    //     <span>The budget for this job will be negotiated by you and the freelancer after the job has been posted.</span>,
    //     <span>You're covered by our <strong>money back guarantee</strong>.</span>,
    //   ];
    // }

    return [];
  }

  getQuestions() {
    const { selectedRole } = this.state;

    if (selectedRole) {
      const defaultQuestions =
        typeof selectedRole.defaultQuestions !== 'undefined'
          ? [...selectedRole.defaultQuestions]
          : [];
      if (selectedRole.questions.length > 0 && defaultQuestions.length > 0) {
        defaultQuestions.forEach((singleQuestion) => {
          singleQuestion.choices.forEach((singleChoice) => {
            if (singleChoice.next === 'skip default') {
              singleChoice.next = selectedRole.questions[0].id;
            }
          });
        });
      }

      return [...defaultQuestions, ...selectedRole.questions];
    }
    return [];
  }

  handleGoogleOAuthCode() {
    const { sendGoogleOAuthCode } = this.props;
    const googleOAuthCode = this.isGoogleOAuthCode();

    if (googleOAuthCode) sendGoogleOAuthCode(googleOAuthCode, 'post', 'buyer');
  }

  isGoogleOAuthCode() {
    const urlString = window.location.href;
    const url = new URL(urlString);
    return url.searchParams.get('code');
  }

  resetLocalProgress = () => {
    try {
      localStorage.removeItem('postingState');
    } catch (error) {
      console.warn('Unable to reset posting progress', error.message);
    }
  };

  saveLocalProgress = () => {
    const {
      answers,
      budget,
      currency,
      currentStep,
      description,
      email,
      fixedBudget,
      phoneNumber,
      selectedRole,
      title,
      freelancer,
      specificFreelancerSelected,
      isPrivate,
    } = this.state;

    try {
      localStorage.setItem(
        'postingState',
        JSON.stringify({
          answers,
          budget,
          currency,
          currentStep,
          description,
          email,
          fixedBudget,
          isPrivate,
          phoneNumber,
          selectedRole,
          title,
          freelancer,
          specificFreelancerSelected,
        })
      );
    } catch (error) {
      // Just don't save anything
      console.warn('Unable to save posting progress', error.message);
    }
  };

  handleAnswerQuestion(question, answer) {
    const { answers } = this.state;
    let newAnswer = answer;

    // If multi, toggle answer from array
    if (question.multi) {
      newAnswer =
        typeof answers[question.id] !== 'undefined' ? answers[question.id] : [];

      const answerPos = newAnswer.indexOf(answer);
      if (answerPos > -1) {
        newAnswer.splice(answerPos, 1);
      } else {
        newAnswer.push(answer);
      }
    }

    this.setState({
      answers: Object.assign({}, answers, { [question.id]: newAnswer }),
    });
  }

  handleBack() {
    scroll({ top: 0, behavior: 'smooth' });

    const {
      history,
      match: { params },
    } = this.props;

    const {
      answers,
      currentStep,
      freelancer,
      questionsSeen,
      selectedRole,
      specificFreelancerSelected,
      // showValidateStep,
    } = this.state;

    let nextStep = currentStep - 1;

    if (
      this.isSelectRoleStep(nextStep) &&
      this.isQuestionsStep(currentStep, this.getQuestions().length) &&
      params.role
    ) {
      history.push('/post');
    }

    // Skip contact details if not special role
    if (
      this.isContactDetailsStep(nextStep, this.getQuestions().length) &&
      !this.isSpecialRole(selectedRole)
    ) {
      nextStep--;
    }

    // Local validation - question step
    if (this.isQuestionsStep(nextStep, this.getQuestions().length)) {
      const questions = this.getQuestions();

      if (questionsSeen.length > 0) {
        const lastQuestionSeen = questionsSeen[questionsSeen.length - 1];

        questions.forEach(function (question, index) {
          if (parseInt(question.id, 10) === parseInt(lastQuestionSeen, 10)) {
            nextStep = 2 + index;
          }
        });

        questionsSeen.splice(questionsSeen.length - 1, 1);

        // remove answer of current question
        const question = questions[currentStep - 2];

        if (question) {
          delete answers[question.id];
        }
      }
    }

    // Skip validate step required
    // if (this.isValidateStep(nextStep, this.getQuestions().length) && ! showValidateStep) {
    //   nextStep--;
    // }

    // Skip the remote step when a specific freelancer is selected
    if (
      this.isRemoteStep(nextStep, this.getQuestions().length) &&
      specificFreelancerSelected
    ) {
      nextStep--;
    }

    // Return to freelancer portofolio instead of select role step if freelancer is selected
    if (
      this.isSelectRoleStep(nextStep, this.getQuestions().length) &&
      specificFreelancerSelected
    ) {
      this.props.history.push(`/${freelancer.username}`);
    }

    this.setState({
      localError: '',
      currentStep: nextStep,
      questionsSeen,
      answers,
    });
  }

  handleChangeRole(role) {
    this.setState(
      {
        answers: {},
        selectedRole: role,
      },
      () => {
        if (typeof role !== 'undefined') {
          this.handleNext();
        }
      }
    );
  }

  handleEmailChange(email) {
    const { specificFreelancerSelected, emailDirty } = this.state;

    if (!emailDirty) {
      trackEvent('post-touched-email', {
        specificFreelancer: specificFreelancerSelected,
        moveSignUpInPostFlow: true,
      });
    }

    this.setState({
      email,
      emailDirty: true,
    });
  }

  findQuestionIndex(questionId) {
    const index = this.getQuestions().findIndex((question) => {
      return question.id === questionId;
    });
    return index;
  }

  findChoiceIndex(question, choiceText) {
    if (question) {
      const index = question.choices.findIndex((choice) => {
        return choice.text === choiceText;
      });
      return index;
    }
    return false;
  }

  handleNext(forceUser = false) {
    const {
      answers,
      currentStep,
      email,
      enteredPostDescription,
      password,
      questionsSeen,
      selectedRole,
      // showValidateStep,
      title,
      workLocallyLocation,
      workRemotely,
      budget,
      fixedBudget,
      specificFreelancerSelected,
      isPrivate,
      description,
    } = this.state;
    const { authUser, loadingAuth, signUp } = this.props;

    let localError = '';
    let nextStep = currentStep + 1;

    if (currentStep === 1) {
      trackEvent('post-clicked-first-next', {
        specificFreelancer: specificFreelancerSelected,
        moveSignUpInPostFlow: true,
      });
    }

    if (
      this.isSearchStep(currentStep, this.getQuestions().length) &&
      selectedRole &&
      !authUser &&
      !loadingAuth &&
      !forceUser
    ) {
      // try sign up
      const signUpDetails = {
        email,
        password,
        type: 'buyer',
        utm: {},
      };

      if (!email || !password) {
        this.setState({
          emailError: !email ? 'You must enter an email to continue' : null,
          passwordError: !password
            ? 'You must enter a password to continue'
            : null,
        });
        return;
      }

      if (typeof cookie.load('utm_source') !== 'undefined') {
        signUpDetails.utm.source = cookie.load('utm_source');
      }

      if (typeof cookie.load('utm_medium') !== 'undefined') {
        signUpDetails.utm.medium = cookie.load('utm_medium');
      }

      if (typeof cookie.load('utm_campaign') !== 'undefined') {
        signUpDetails.utm.campaign = cookie.load('utm_campaign');
      }

      if (typeof cookie.load('utm_term') !== 'undefined') {
        signUpDetails.utm.term = cookie.load('utm_term');
      }

      if (typeof cookie.load('utm_content') !== 'undefined') {
        signUpDetails.utm.content = cookie.load('utm_content');
      }

      if (this.recaptcha) {
        this.setState(
          { signUpDetails, emailError: null, passwordError: null },
          () => {
            this.recaptcha.execute();
          }
        );
      } else {
        signUp(signUpDetails);
      }

      if (this.recaptcha) {
        this.recaptcha.reset();
      }

      return;
    }

    // Local validation - select role step
    if (this.isSelectRoleStep(currentStep)) {
      if (!selectedRole) {
        localError = 'Please choose a role you need, then click next';
      }
    }

    // Local validation - question step
    if (this.isQuestionsStep(currentStep, this.getQuestions().length)) {
      const questions = this.getQuestions();
      const question = questions[currentStep - 2];
      questionsSeen.push(question.id);

      // check if the question choice has a next
      if (
        !question.multi &&
        question.choices.length > 0 &&
        answers[question.id] !== 'undefined'
      ) {
        question.choices.forEach(function (choice) {
          if (
            choice.text === answers[question.id] &&
            typeof choice.next !== 'undefined'
          ) {
            let answeredQuestionIndex;
            let nextQuestionIndex;
            questions.forEach(function (checkQuestion, index) {
              if (
                parseInt(checkQuestion.id, 10) === parseInt(question.id, 10)
              ) {
                answeredQuestionIndex = index;
              }

              if (
                parseInt(checkQuestion.id, 10) === parseInt(choice.next, 10)
              ) {
                nextQuestionIndex = index;
              }
            });

            nextStep =
              currentStep + (nextQuestionIndex - answeredQuestionIndex);
          }
        });
      }

      if (question.required && typeof answers[question.id] === 'undefined') {
        localError = 'Please choose your answer then click next';
      }
    }

    // update nextStep & trigger trackEvent if default questions have been completed.
    if (questionsSeen.length > 0) {
      const lastQuestionId = questionsSeen[questionsSeen.length - 1];
      const lastQuestion =
        this.getQuestions()[this.findQuestionIndex(lastQuestionId)];
      const lastChoice = lastQuestion.multi
        ? { next: false }
        : lastQuestion.choices[
            this.findChoiceIndex(lastQuestion, answers[lastQuestionId])
          ];
      let shouldSkipDefault;
      if (lastChoice) {
        if (lastChoice.next) {
          shouldSkipDefault = lastChoice.next === 'skip default';
        }
      }
      if (answers[lastQuestionId] !== 'other') {
        if (
          this.isQuestionsStep(currentStep, this.getQuestions().length) &&
          selectedRole.questions.length === 0 &&
          shouldSkipDefault
        ) {
          nextStep = this.getQuestions().length + 2;
        }
      }
      let noSpecificAndNoSkip = false;
      if (typeof selectedRole.questions[0] === 'undefined') {
        noSpecificAndNoSkip =
          lastQuestionId ===
          this.getQuestions()[this.getQuestions().length - 1].id;
      }
      let specificAndNoSkip = false;
      let specificAndSkip = false;
      if (typeof selectedRole.questions[0] !== 'undefined') {
        specificAndNoSkip =
          lastQuestionId ===
          [...selectedRole.defaultQuestions][
            [...selectedRole.defaultQuestions].length - 1
          ].id;
        if (lastChoice) {
          if (lastChoice.next) {
            const nextQuestionIndex = this.findQuestionIndex(lastChoice.next);
            if (nextQuestionIndex > 0) {
              const nextQuestionId = this.getQuestions()[nextQuestionIndex].id;
              specificAndSkip = nextQuestionId === selectedRole.questions[0].id;
            }
          }
        }
      }
      const shouldTrackDefaultCompleted =
        shouldSkipDefault ||
        specificAndNoSkip ||
        specificAndSkip ||
        noSpecificAndNoSkip;
      if (shouldTrackDefaultCompleted) {
        const trackEventInfo = {
          specificFreelancer: specificFreelancerSelected,
          moveSignUpInPostFlow: true,
        };
        if (authUser) {
          trackEventInfo.userId = authUser.id;
        }
        trackEvent('post-default-questions-complete', trackEventInfo);
      }
    }

    // Check if the next step is the remote step
    if (this.isRemoteStep(currentStep + 1, this.getQuestions().length)) {
      // Skip this step if we are hiring a specific freelancer
      if (specificFreelancerSelected) {
        nextStep++;
        // Set isPrivate to true the first time you enter the PostDescription step when hiring a specific freelancer
        // Also set the brief title to the autogenerated one
        if (enteredPostDescription === false) {
          this.setState({
            isPrivate: !isPrivate,
            enteredPostDescription: true,
          });
        }
      }
    }

    // Local validation - remote step
    if (this.isRemoteStep(currentStep, this.getQuestions().length)) {
      if (!workRemotely && !workLocallyLocation) {
        localError = 'Please enter a country or city';
      }
    }

    // Local validation - remote step
    if (this.isBudgetStep(currentStep, this.getQuestions().length)) {
      if (fixedBudget && budget < config.minimumBudget) {
        localError = `Minimum budget value is ${config.minimumBudget / 100}`;
      }
    }

    // Local validation - description step
    if (this.isDescriptionStep(currentStep, this.getQuestions().length)) {
      const templates = this.getDescriptionTemplate();

      // Clear description if it's same as the template
      Object.keys(templates).forEach((template) => {
        if (templates[template] === description) {
          this.setState({ description: '' });
        }
      });

      if (title.length <= 0) {
        localError = 'Please add a project title';
      } else if (title.length < 5) {
        localError =
          'Your project title needs to be more than 4 characters long';
      }

      const minimumJobDescriptionLength = 10;
      if (description.length < minimumJobDescriptionLength) {
        localError = `Add a few words explaining your project in the Description box`;
      }
    }

    // Start searcher
    // if (currentStep === this.getQuestions().length + 5) {
    if (this.isSearchStep(nextStep, this.getQuestions().length)) {
      this.setState({
        searching: true,
      });

      setTimeout(() => {
        this.setState({
          searching: false,
        });
      }, 3000);
    }

    // Skip contact details if not special role
    if (
      this.isContactDetailsStep(nextStep, this.getQuestions().length) &&
      !this.isSpecialRole(selectedRole)
    ) {
      nextStep++;
    }

    // Skip validate step if required
    // if (this.isValidateStep(nextStep, this.getQuestions().length) && ! showValidateStep) {
    //   nextStep++;
    // }

    this.setState(
      {
        currentStep: localError !== '' ? currentStep : nextStep,
        localError,
        questionsSeen,
      },
      () => {
        // If no error, so we are changing step, fire tracking for nextStep
        if (localError === '') {
          if (this.isDescriptionStep(nextStep, this.getQuestions().length)) {
            trackEvent('post-viewed-description', {
              specificFreelancer: specificFreelancerSelected,
              moveSignUpInPostFlow: true,
            });
          }

          if (this.isBudgetStep(nextStep, this.getQuestions().length)) {
            trackEvent('post-viewed-budget', {
              specificFreelancer: specificFreelancerSelected,
              moveSignUpInPostFlow: true,
            });
          }

          if (this.isRemoteStep(nextStep, this.getQuestions().length)) {
            trackEvent('post-viewed-location-step', {
              specificFreelancer: specificFreelancerSelected,
              moveSignUpInPostFlow: true,
            });
          }

          if (this.isSearchStep(nextStep, this.getQuestions().length)) {
            trackEvent('post-viewed-searching-step', {
              specificFreelancer: specificFreelancerSelected,
              moveSignUpInPostFlow: true,
            });
          }

          // if (this.isValidateStep(nextStep, this.getQuestions().length)) {
          //   trackEvent('post-viewed-validation');
          // }
        }
      }
    );

    if (localError === '') {
      scroll({ top: 0, behavior: 'smooth' });
    }
  }

  handlePasswordChange(password) {
    const { passwordDirty, specificFreelancerSelected } = this.state;

    if (!passwordDirty) {
      trackEvent('post-touched-password', {
        specificFreelancer: specificFreelancerSelected,
        moveSignUpInPostFlow: true,
      });
    }

    this.setState({
      password,
      passwordDirty: true,
    });
  }

  handleToggleContactDetails(type) {
    const { userContactOptions } = this.state;

    this.setState({
      userContactOptions: Object.assign({}, userContactOptions, {
        [type]: !userContactOptions[type],
      }),
      userContactOptionsUpdated: true,
    });
  }

  handleRecaptchaResolved() {
    const { signUpDetails } = this.state;
    const { signUp } = this.props;

    signUpDetails.recaptcha = this.recaptcha.getResponse();

    signUp(signUpDetails);

    this.setState({ signUpDetails: null });
  }

  isSelectRoleStep(currentStep) {
    return currentStep === 1;
  }

  isQuestionsStep(currentStep, noOfQuestions) {
    return currentStep > 1 && currentStep <= noOfQuestions + 1;
  }

  isRemoteStep(currentStep, noOfQuestions) {
    return currentStep === noOfQuestions + 2;
  }

  isDescriptionStep(currentStep, noOfQuestions) {
    return currentStep === noOfQuestions + 3;
  }

  isBudgetStep(currentStep, noOfQuestions) {
    return currentStep === noOfQuestions + 4;
  }

  isBoostStep(currentStep, noOfQuestions) {
    return currentStep === noOfQuestions + 5;
  }

  isSearchStep(currentStep, noOfQuestions) {
    return currentStep === noOfQuestions + 6;
  }

  isContactDetailsStep(currentStep, noOfQuestions) {
    return currentStep === noOfQuestions + 7;
  }

  // isValidateStep(currentStep, noOfQuestions) {
  //   return currentStep === noOfQuestions + 7;
  // }

  isSpecialRole(role) {
    return role.special;
  }

  postBrief(saveContactDetails = false) {
    const {
      phoneNumber,
      phoneNumberUpdated,
      userContactOptions,
      userContactOptionsUpdated,
      answers,
      workLocallyLocation,
      title,
      selectedRole,
      fixedBudget,
      budget,
      currency,
      isPrivate,
      workRemotely,
      specificFreelancerSelected,
      externalUrl,
    } = this.state;

    const { updateAuthUser, authUser, postBrief } = this.props;

    const userCanPostExternalUrl = authUser
      ? authUser.external_url_permission
      : false;

    if (__CLIENT__) {
      window.onbeforeunload = null;
    }

    // Save braintree details if required
    // if (braintreeNonce) {
    //   this.props.saveBraintreeNonce(this.props.authUser, braintreeNonce);
    // }

    // Save contact details if required
    if (saveContactDetails) {
      // Contact details validation
      const digits = phoneNumber.match(/\d+/g);

      if (
        (userContactOptions.phone || userContactOptions.sms) &&
        (!digits || digits.join('').length < SHORTEST_INTL_PHONE_LENGTH)
      ) {
        return (
          this.setState({
            localError:
              'Please enter a valid phone number or unselect Phone as a contact option',
          }),
          flashHighlight('post-brief-phone-number')
        );
      }
      this.setState({ localError: '' });
      if (userContactOptionsUpdated || phoneNumberUpdated) {
        updateAuthUser(
          authUser,
          {
            contact_options: userContactOptions,
            ...(userContactOptions.phone || userContactOptions.sms
              ? { phone: phoneNumber }
              : {}),
          },
          true
        );
      }
    }

    const links = this.state.links ? `${this.state.links}\n\n` : '';

    let description =
      this.state.description +
      (this.state.description.trim() !== '' ? '\n\n' : '');
    description += links;
    for (let idx = 0; idx < this.getQuestions().length; idx++) {
      if (typeof answers[this.getQuestions()[idx].id] !== 'undefined') {
        description += `**${this.getQuestions()[idx].text}**\n`;
        description += `${
          this.getQuestions()[idx].multi
            ? answers[this.getQuestions()[idx].id].join(', ')
            : answers[this.getQuestions()[idx].id]
        }\n\n`;
      }
    }
    // post brief
    postBrief(
      title,
      description,
      selectedRole.type === 'role' ? selectedRole.name : null,
      selectedRole.type === 'skill' ? selectedRole.name : null,
      !fixedBudget || budget === 0 ? -1 : budget,
      currency,
      answers,
      isPrivate,
      workRemotely,
      !workRemotely && workLocallyLocation
        ? {
            lat: workLocallyLocation.lat ? workLocallyLocation.lat : null,
            lon: workLocallyLocation.lon ? workLocallyLocation.lon : null,
            location_text:
              workLocallyLocation.city && workLocallyLocation.country
                ? workLocallyLocation.city + ', ' + workLocallyLocation.country
                : workLocallyLocation.country,
            countryOnly: workLocallyLocation.countryOnly
              ? workLocallyLocation.countryOnly
              : null,
          }
        : null,
      userCanPostExternalUrl ? externalUrl : ''
    );

    // Clear cookies after posting job
    cookie.remove('post-description');
    cookie.remove('post-title');
    cookie.remove('post-capacity');
    cookie.remove('post-process');
    cookie.remove('post-size');
    cookie.remove('post-time');
    cookie.remove('post-email');
    cookie.remove('post-phone');

    trackEvent('post-posted-brief', {
      user: authUser.id,
      role: selectedRole.type === 'role' ? selectedRole.name : null,
      skill: selectedRole.type === 'skill' ? selectedRole.name : null,
      specificFreelancer: specificFreelancerSelected,
      moveSignUpInPostFlow: true,
    });
  }

  resumeBrief(confirm = false) {
    if (confirm) {
      const newState = JSON.parse(localStorage.getItem('postingState'));
      newState.showContinue = false;
      // If not logged in show first step
      newState.currentStep = newState.currentStep || 1;

      this.setState(newState);
      return;
    }

    if (
      __CLIENT__ &&
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('postingState')
    ) {
      this.setState({ showContinue: true });
    }
  }

  selectRoleByName(name, autoSelect = false) {
    const { roleEntities, suggestedSkills, suggestedRoles, skillEntities } =
      this.props;

    let foundRole = false;

    for (const roleId of suggestedRoles) {
      if (roleEntities[roleId].name.toLowerCase() === name.toLowerCase()) {
        foundRole = true;

        this.setState(
          {
            selectedRole: roleEntities[roleId],
            autoSelectedRole: autoSelect,
          },
          () => {
            // eslint-disable-line no-loop-func
            if (autoSelect) {
              this.handleNext();
            }
          }
        );

        break;
      }
    }

    // Not found the role, could be a skill
    if (!foundRole) {
      for (const skillId of suggestedSkills) {
        if (skillEntities[skillId].name.toLowerCase() === name.toLowerCase()) {
          foundRole = true;

          this.setState(
            {
              selectedRole: skillEntities[skillId],
              autoSelectedRole: autoSelect,
            },
            () => {
              // eslint-disable-line no-loop-func
              if (autoSelect) {
                this.handleNext();
              }
            }
          );

          break;
        }
      }
    }
  }

  updateCurrencyOnLocationChange = () => {
    const {
      wasCurrencyUpdatedByUser,
      workLocallyLocation: { country_code: jobCountryCode },
    } = this.state;
    const authUser = this.props;
    const userCountryCode = authUser?.location?.country_code;

    if (!wasCurrencyUpdatedByUser) {
      const countryCode = jobCountryCode || userCountryCode || '';

      return this.setState({
        currency: /(gb|GB)/.test(countryCode) ? 'gbp' : 'usd',
      });
    }
  };

  render() {
    const {
      authUser,
      loadingSuggestedRoles,
      postingBrief,
      roleEntities,
      signingUp,
      suggestedRoles,
      stats,
      signingUpViaGoogle,
      googleOAuthRedirect,
    } = this.props;

    // Props emailError and passwordError are from the server
    // State emailError and passwordError are from the front-end validation
    // Give the server error messages precedence over the front-end validation
    const emailError = this.props.emailError.length
      ? this.props.emailError
      : this.state.emailError;
    const passwordError = this.props.passwordError.length
      ? this.props.passwordError
      : this.state.passwordError;
    const userCanPostExternalUrl = authUser
      ? authUser.external_url_permission
      : false;

    const {
      answers,
      autoSelectedRole,
      budget,
      currency,
      currentStep,
      description,
      email,
      externalUrl,
      freelancer,
      fixedBudget,
      isPrivate,
      localError,
      password,
      phoneNumber,
      // showValidateStep,
      searching,
      selectedRole,
      showContinue,
      title,
      titleChangedByUser,
      links,
      userContactOptions,
      showTrustSectionAB,
      showExplainer,
      specificFreelancerSelected,
      workLocallyLocation,
      workRemotely,
    } = this.state;

    if (showContinue) {
      const prevRole = JSON.parse(localStorage.getItem('postingState'))
        .selectedRole.name;
      const isProcessingGoogle = this.isGoogleOAuthCode() || signingUpViaGoogle;

      if (isProcessingGoogle) {
        this.resumeBrief(true);
        window.history.replaceState('', '', '/post');
      } else {
        return (
          <Clearfix>
            <div className={styles.resume}>
              <Helmet
                title="Welcome back!"
                link={[{ rel: 'canonical', href: `${config.baseUrl}/post` }]}
              />
              <h4>Welcome back!</h4>
              <p>
                Would you like to resume your previous brief for{' '}
                {beginsWithVowel(prevRole) ? 'an' : 'a'}{' '}
                <strong>{prevRole}</strong>?
              </p>
              <Button
                block
                bsStyle="primary"
                bsSize="large"
                onClick={() => this.resumeBrief(true)}
              >
                Continue
              </Button>
              <Button
                block
                bsStyle="primary"
                bsSize="large"
                onClick={() => {
                  this.setState({ showContinue: false });
                  this.resetLocalProgress();
                }}
              >
                Start again
              </Button>
            </div>
          </Clearfix>
        );
      }
    }

    const helpPoints = this.getHelpPoints(
      currentStep,
      this.getQuestions().length,
      fixedBudget
    );

    const usersCount = (Math.round(stats.count / 10000) * 10000).toLocaleString(
      'en-US',
      { minimumFractionDigits: 0 }
    );

    const templates = this.getDescriptionTemplate();

    const shouldDisplayPostFlowIndicator = !(
      !authUser && specificFreelancerSelected
    );

    return (
      <div className={`${styles.container}`}>
        <Helmet
          title="Post your job on Twine"
          link={[{ rel: 'canonical', href: `${config.baseUrl}/post` }]}
          meta={[
            {
              name: 'description',
              content:
                'Post your job on Twine to match to the perfect freelancer',
            },
            { property: 'og:title', content: 'Post your job on Twine' },
            { property: 'og:description', content: description },
            { property: 'og:url', href: `${config.baseUrl}/post` },
            { name: 'twitter:title', content: 'Post your job on Twine' },
            {
              name: 'twitter:description',
              content:
                'Post your job on Twine to match to the perfect freelancer',
            },
          ]}
        />
        <Grid>
          {currentStep > 1 && (
            <Row>
              <Col
                xs={12}
                md={10}
                mdPush={1}
                style={{ margin: '10px 0 10px 0' }}
              >
                <PostStepsIndicator
                  currentStep={
                    this.isContactDetailsStep(
                      currentStep,
                      this.getQuestions().length
                    )
                      ? 3
                      : 2
                  }
                  totalSteps={this.isSpecialRole(selectedRole) ? 4 : 3}
                />
              </Col>
            </Row>
          )}
          <Row>
            {this.isSelectRoleStep(currentStep) &&
              shouldDisplayPostFlowIndicator && <PostFlowIndicator />}
            <Col
              xs={12}
              sm={8}
              smPush={2}
              md={
                this.isSearchStep(currentStep, this.getQuestions().length) &&
                !authUser
                  ? 12
                  : 6
              }
              mdPush={
                (this.isSelectRoleStep(currentStep) &&
                  showTrustSectionAB === 'b') ||
                helpPoints.length > 0
                  ? 1
                  : this.isSearchStep(
                      currentStep,
                      this.getQuestions().length
                    ) && !authUser
                  ? 0
                  : 3
              }
            >
              {signingUpViaGoogle && (
                <div className={styles.googleLoaderContainer}>
                  <div className={styles.googleLoader}>
                    <p className="lato-bold fs-16">Connecting to Google...</p>
                    <Loader loading />
                  </div>
                </div>
              )}
              {this.isSelectRoleStep(currentStep) && (
                <PostSelectRole
                  availableRoles={suggestedRoles.map((id) => roleEntities[id])}
                  currentRole={selectedRole}
                  loadingAvailableRoles={loadingSuggestedRoles}
                  onChangeRole={(selectedRole) =>
                    this.handleChangeRole(selectedRole)
                  }
                  handleNext={() => this.handleNext()}
                />
              )}
              {this.isSearchStep(currentStep, this.getQuestions().length) &&
                process.env.GOOGLE_RECAPTCHA_API_KEY && (
                  <Recaptcha
                    ref={(ref) => (this.recaptcha = ref)}
                    sitekey={process.env.GOOGLE_RECAPTCHA_API_KEY}
                    onResolved={this.handleRecaptchaResolved.bind(this)}
                  />
                )}
              {this.isQuestionsStep(
                currentStep,
                this.getQuestions().length
              ) && (
                <PostQuestion
                  selectedAnswer={
                    typeof answers[this.getQuestions()[currentStep - 2].id] !==
                    'undefined'
                      ? answers[this.getQuestions()[currentStep - 2].id]
                      : this.getQuestions()[currentStep - 2].multi
                      ? []
                      : null
                  }
                  answers={this.getQuestions()[currentStep - 2].choices}
                  multi={this.getQuestions()[currentStep - 2].multi}
                  firstQuestion={currentStep === 2}
                  onAnswer={(answer) =>
                    this.handleAnswerQuestion(
                      this.getQuestions()[currentStep - 2],
                      answer
                    )
                  }
                  other={this.getQuestions()[currentStep - 2].allow_other}
                  question={this.getQuestions()[currentStep - 2].text}
                  role={selectedRole.name}
                  freelancer={freelancer}
                />
              )}
              {this.isRemoteStep(currentStep, this.getQuestions().length) && (
                <PostRemote
                  onChangeRemote={(value) =>
                    this.setState({ workRemotely: value })
                  }
                  remoteSelected={workRemotely}
                  locationSelected={!!workLocallyLocation}
                  onChangeLocation={(location) =>
                    this.setState(
                      { workLocallyLocation: location },
                      this.updateCurrencyOnLocationChange
                    )
                  }
                />
              )}
              {this.isDescriptionStep(
                currentStep,
                this.getQuestions().length
              ) && (
                <PostDescription
                  description={description}
                  templates={templates}
                  onChangeDescription={(description) =>
                    this.setState({ description })
                  }
                  onChangeLinks={(links) => this.setState({ links })}
                  onTogglePrivate={() =>
                    this.setState({ isPrivate: !isPrivate })
                  }
                  onTitleChangedByUser={(title) =>
                    this.setState({ title, titleChangedByUser: true })
                  }
                  projectPrivate={isPrivate}
                  title={title}
                  titleChangedByUser={titleChangedByUser}
                  links={links}
                  freelancer={freelancer}
                  specificFreelancerSelected={specificFreelancerSelected}
                  userCanPostExternalUrl={userCanPostExternalUrl}
                  externalUrl={externalUrl}
                  onChangeExternalUrl={(externalUrl) =>
                    this.setState({ externalUrl })
                  }
                />
              )}
              {this.isBudgetStep(currentStep, this.getQuestions().length) && (
                <PostBudget
                  budget={budget}
                  currency={currency}
                  fixedBudget={fixedBudget}
                  onChangeBudget={(budget) => this.setState({ budget })}
                  onChangeCurrency={(currency) =>
                    this.setState({ currency, wasCurrencyUpdatedByUser: true })
                  }
                  onSetFixedBudget={(fixedBudget) =>
                    this.setState({ fixedBudget })
                  }
                  specificFreelancerSelected={specificFreelancerSelected}
                  isPrivate={isPrivate}
                />
              )}
              {this.isBoostStep(currentStep, this.getQuestions().length) && (
                <PostBoost nextFunction={() => this.handleNext()} />
              )}
              {this.isSearchStep(currentStep, this.getQuestions().length) &&
                (authUser ? (
                  <>
                    <PostSearchCreatives
                      searching={searching}
                      freelancer={freelancer}
                      specificFreelancerSelected={specificFreelancerSelected}
                      isPrivate={isPrivate}
                    />
                  </>
                ) : (
                  <>
                    <PostSearchCreatives
                      searching={searching}
                      freelancer={freelancer}
                      specificFreelancerSelected={specificFreelancerSelected}
                      isPrivate={isPrivate}
                    />
                    <PostSignUp
                      onChangeEmail={(email) => this.handleEmailChange(email)}
                      onChangePassword={(password) =>
                        this.handlePasswordChange(password)
                      }
                      loadingState={signingUp}
                      googleOAuthRedirect={googleOAuthRedirect}
                      email={email}
                      emailError={emailError}
                      errorState
                      password={password}
                      passwordError={passwordError}
                      signedIn={!!authUser}
                      handleNext={() => this.handleNext()}
                    />
                  </>
                ))}
              {this.isContactDetailsStep(
                currentStep,
                this.getQuestions().length
              ) && (
                <PostContactDetails
                  email={userContactOptions.email}
                  none={
                    !userContactOptions.email &&
                    !userContactOptions.phone &&
                    !userContactOptions.sms
                  }
                  onChangePhoneNumber={(phoneNumber) =>
                    this.setState({ phoneNumber, phoneNumberUpdated: true })
                  }
                  onToggleEmail={() => this.handleToggleContactDetails('email')}
                  onToggleNone={() =>
                    this.setState({
                      userContactOptions: {
                        email: false,
                        phone: false,
                        sms: false,
                      },
                      userContactOptionsUpdated: true,
                    })
                  }
                  onTogglePhone={() => this.handleToggleContactDetails('phone')}
                  onToggleSms={() => this.handleToggleContactDetails('sms')}
                  phone={userContactOptions.phone}
                  phoneNumber={phoneNumber}
                  sms={userContactOptions.sms}
                />
              )}
              {/* (this.isValidateStep(currentStep, this.getQuestions().length) && showValidateStep) &&
              <PostValidate
                onPaymentMethodReceived={(obj) => this.postBrief(obj.nonce)}
                paymentToken={paymentToken} /> */}
              {!(
                this.isSearchStep(currentStep, this.getQuestions().length) &&
                searching
              ) && (
                <div className="text-center cf mt++">
                  <div
                    className={styles.localError}
                    style={{ maxHeight: localError === '' ? 0 : '40px' }}
                  >
                    {localError}
                  </div>
                  {currentStep > 1 && (
                    <Button
                      bsStyle="link"
                      id="post-brief-back-button"
                      className="left"
                      onClick={() => this.handleBack()}
                    >
                      &lt;&nbsp;Back
                    </Button>
                  )}
                  {!signingUpViaGoogle &&
                    !(
                      this.isContactDetailsStep(
                        currentStep,
                        this.getQuestions().length
                      ) ||
                      (this.isSearchStep(
                        currentStep,
                        this.getQuestions().length
                      ) &&
                        !this.isSpecialRole(selectedRole) &&
                        !searching)
                    ) &&
                    // Do not display this button when the sign up step is visible
                    !!selectedRole &&
                    !(
                      this.isSearchStep(
                        currentStep,
                        this.getQuestions().length
                      ) && !authUser
                    ) && (
                      <Button
                        bsStyle="success"
                        id="post-brief-next-button"
                        className={
                          !this.isSelectRoleStep(currentStep) ? 'right' : ''
                        }
                        onClick={() => this.handleNext()}
                        disabled={signingUp}
                      >
                        {this.isSelectRoleStep(currentStep) &&
                        // authUser &&
                        autoSelectedRole
                          ? 'Get Started'
                          : 'Next'}
                        &nbsp;&gt;
                      </Button>
                    )}
                  {(this.isContactDetailsStep(
                    currentStep,
                    this.getQuestions().length
                  ) ||
                    (this.isSearchStep(
                      currentStep,
                      this.getQuestions().length
                    ) &&
                      authUser &&
                      !this.isSpecialRole(selectedRole) &&
                      !searching)) && (
                    <Button
                      bsStyle="success"
                      className="right"
                      id="post-brief-button"
                      onClick={() =>
                        this.postBrief(
                          this.isContactDetailsStep(
                            currentStep,
                            this.getQuestions().length
                          )
                        )
                      }
                      disabled={postingBrief}
                    >
                      {postingBrief ? 'Posting...' : 'Post and review'}
                    </Button>
                  )}
                  {this.isSelectRoleStep(currentStep) && (
                    <div className="mt++ fs-15">
                      <div className={styles.freelancerBox}>
                        {"If you're a freelancer looking for work, "}
                        <a
                          href="/freelancers"
                          onClick={() => {
                            window.onbeforeunload = null;
                          }}
                        >
                          click here
                        </a>
                        .
                      </div>
                    </div>
                  )}
                </div>
              )}
              {helpPoints.length > 0 && <div className={styles.divider} />}
            </Col>
            {this.isSelectRoleStep(currentStep) && showTrustSectionAB === 'b' && (
              <Col
                className={`${styles.trustSection} ${styles.trustBorder} hidden-xs hidden-sm`}
                xs={12}
                md={4}
                mdPush={1}
              >
                <p className="aside-text fs-15">
                  Our freelancers are trusted by:
                </p>
                <Col xs={6}>
                  <LazyLoad>
                    <img src={cocacola} alt="Coca Cola" className="relative" />
                  </LazyLoad>
                </Col>
                <Col xs={6}>
                  <LazyLoad>
                    <img src={disney} alt="Disney" className="relative" />
                  </LazyLoad>
                </Col>
                <Col xs={6}>
                  <LazyLoad>
                    <img src={mtv} alt="MTV" className="relative" />
                  </LazyLoad>
                </Col>
                <Col xs={6}>
                  <LazyLoad>
                    <img src={muppets} alt="Muppets" className="relative" />
                  </LazyLoad>
                </Col>
                <Col xs={6}>
                  <LazyLoad>
                    <img src={nokia} alt="Nokia" className="relative" />
                  </LazyLoad>
                </Col>
                <Col xs={6}>
                  <LazyLoad>
                    <img src={starWars} alt="Star wars" />
                  </LazyLoad>
                </Col>
              </Col>
            )}
            {helpPoints.length > 0 && (
              <Col xs={12} md={4} mdPush={1}>
                <PostHelp
                  points={helpPoints}
                  style={{ marginBottom: '20px' }}
                />
                {this.isSpecialRole(selectedRole) && <PostScheduleCall />}
                {/* <PostVoucherInfo /> */}
              </Col>
            )}
          </Row>
          {/* this.isValidateStep(currentStep, this.getQuestions().length) &&
          <Row>
            <Col xs={12}>
              <div className={styles.infoList}>
                <p>You're in good company. Our freelancers have worked with:</p>
                <img alt="Twine" src={cocacola} />
                <img alt="Twine" src={disney} />
                <img alt="Twine" src={mtv} />
                <img alt="Twine" src={muppets} />
                <img alt="Twine" src={nokia} />
                <img alt="Twine" src={starWars} />
              </div>
            </Col>
          </Row> */}
        </Grid>
        <PostFooter
          step={this.isSelectRoleStep(currentStep) ? 'roleStep' : ''}
          usersCount={usersCount}
          onShowExplainer={() => this.setState({ showExplainer: true })}
        />
        <ExplainerVideoModal
          show={showExplainer}
          onExit={() => this.setState({ showExplainer: false })}
        />
      </div>
    );
  }
}
